export default __webpack_public_path__ + "static/1-2a2f2bab047a9b0b406b14cac01d5de3.png";